import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:{},
    token:{},
    post: {},
    map: {},
    formId:1,
    showStepmanager:false,
    isAnonymous:false,
    redirect:'',
    consultUrl:'',
    vueAppBackendUrl:'',
    vueAppModernApiUrl:'',
    vueAppBaseUrl:'',
    MapCountryRestrict:'',
    MapCityRestrict:'',
  },
  mutations: {
    setUser: function (state, user) { state.user = user },
    setToken: function (state, token) { state.token = token },
    setPost: function (state, post) { state.post = post },
    setMap: function (state, map) { state.map = map },
    setFormId: function (state, formId) { state.formId = formId },
    setStepmanager: function (state, showStepmanager) { state.showStepmanager = showStepmanager },
    setAnonymous: function (state, isAnonymous) { state.isAnonymous = isAnonymous },
    setRedirectPage: function (state, redirect) { state.redirect = redirect },
    setConsultUrl: function (state, consultUrl) { state.consultUrl = consultUrl },
    setVueAppBackendUrl: function (state, vueAppBackendUrl) { state.vueAppBackendUrl = vueAppBackendUrl },
    setVueAppModernApiUrl: function (state, vueAppModernApiUrl) { state.vueAppModernApiUrl = vueAppModernApiUrl },
    setVueAppBaseUrl: function (state, vueAppBaseUrl) { state.vueAppBaseUrl = vueAppBaseUrl },
    setMapCountryRestrinction: function (state, MapCountryRestrict) { state.MapCountryRestrict = MapCountryRestrict },
    setMapCityRestrinction: function (state, MapCityRestrict) { state.MapCityRestrict = MapCityRestrict },

  },
  actions: {
  },
  modules: {
  }
})
